import React from 'react'
import { specifyOrderStatus, IOrder } from 'orders/schema'
import InlineEmail from '../commons/inlineEmail'
import InlineVisitDate from '../commons/inlineVisitDate'
import InlineVisitTime from '../commons/inlineVisitTime'
import StatusLabel from '../commons/orderStatusLabel'
import { DiscountCodesElement } from 'orders/helpers'
import DataItem from './components/dataItem'
import { formatTimestamp, getDiscountCodesString } from '../utils'
import { useAppDispatch } from 'store/hooks'
import { selectOrder } from '../redux'
import { getDistinctPaymentMethods, getPaymentToDisplay } from '../ordersTable/columns'
import OrderComment from '../comment/orderComment'
import { CopyIcon } from 'uiComponents/buttons/copyIcon'
import { capitalize } from 'lodash'
import { useTranslation } from 'translations'

const OrderInfo = ({ order }: { order: IOrder }) => {
    const { t } = useTranslation()
    const paymentToDisplay = getPaymentToDisplay(order.payments)
    const dispatch = useAppDispatch()

    return (
        <div className="content">
            <div className="order-info">
                <div className="column">
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.orderId')}>
                        {order.number}&nbsp;
                        <CopyIcon text={order.number} />
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.email')}>
                        <InlineEmail
                            order={order}
                            onUpdated={(order) => {
                                dispatch(selectOrder(order))
                            }}
                        />
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.paymentUpdatedAt')}>
                        {paymentToDisplay?.paymentDate
                            ? formatTimestamp(paymentToDisplay.paymentDate, order.timezone)
                            : '-'}
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.visitDate')}>
                        <InlineVisitDate
                            order={order}
                            onUpdated={(order) => {
                                dispatch(selectOrder(order))
                            }}
                        />
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.visitTime')}>
                        <InlineVisitTime
                            order={order}
                            onUpdated={(order) => {
                                dispatch(selectOrder(order))
                            }}
                        />
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.discountCodes')}>
                        <DiscountCodesElement discountsString={getDiscountCodesString(order)} />
                    </DataItem>
                </div>
                <div className="column">
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.orderStatus')}>
                        <StatusLabel status={specifyOrderStatus(order)} />
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.paymentStatus')}>
                        <StatusLabel status={paymentToDisplay?.paymentStatus ?? 'unpaid'} />
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.salesChannel')}>
                        {order.orderSource ? capitalize(order.orderSource) : '-'}
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.paymentMethod')}>
                        {getDistinctPaymentMethods(order.payments).join(', ') || '-'}
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.emailStatus')}>
                        {order.emailStatus}
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.downloaded')}>
                        {order.downloaded ? formatTimestamp(order.downloaded, order.timezone) : '-'}
                    </DataItem>
                    <DataItem className="row" name={t('orders.orders.orderDetails.info.reseller')}>
                        {order.reseller.name ? order.reseller.name : '-'}
                    </DataItem>
                </div>
                <OrderComment orderId={order.id} />
            </div>
        </div>
    )
}

export default OrderInfo
